import React, {useEffect, useState} from 'react';
import Wrapper from "../components/Wrapper.js";
import {Link} from "react-router";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import {DndContext} from "@dnd-kit/core";
import TeamBoard from "../components/DragAndDrop/TeamBoard.js";
import Api from "../Api.js";
import SuccessToast from "../components/BlueButton/SuccessToast.js";

export const teams = [
    {id: 'team-a', name: 'Team A'},
    {id: 'team-b', name: 'Team B'},
    {id: 'team-c', name: 'Team C'},
];

export const initialEmployees = {
    'team-a': [{id: 'emp-1', name: 'John Doe'}],
    'team-b': [{id: 'emp-2', name: 'Jane Smith'}],
    'team-c': [{id: 'emp-3', name: 'Alex Brown'}],
};

function StaffTeams(props) {
    const [teams, setTeams] = useState([]);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState({}); // object: { teamId: [employees] }

    useEffect(() => {
        (async () => {
            try {
                const { data } = await Api.getTeam(); // Your API endpoint
                const result = {};

                data.results.forEach(group => {
                    result[String(group.id)] = group.accountants; // make team IDs strings
                });
                console.log("Formatted employees:", result);

                setEmployees(result);
                setTeams(data.results); // for rendering columns
            } catch (err) {
                console.error("Failed to fetch teams", err);
            }
        })();
    }, []);

    const handleDragEnd = async (event) => {
        const { active, over } = event;

        if (!over) {
            console.log("Dropped outside any target");
            return;
        }

        const activeId = String(active.id);
        const overId = String(over.id);

        const sourceTeamId = Object.keys(employees).find(teamId =>
            employees[teamId].some(emp => String(emp.id) === activeId)
        );

        console.log("Dragged from:", sourceTeamId, "to:", overId);

        if (!sourceTeamId || sourceTeamId === overId) return;

        const movedEmp = employees[sourceTeamId].find(emp => String(emp.id) === activeId);
        if (!movedEmp) {
            console.error("Could not find employee to move");
            return;
        }

        try {
            setLoading(overId)
            await Api.moveTeam({
                accountant_id: activeId,
                target_group_id: overId
            });

            setEmployees((prev) => {
                // Ensure overId has a valid array
                const newSourceList = prev[sourceTeamId].filter(emp => String(emp.id) !== activeId);
                const newTargetList = [...(prev[overId] || []), movedEmp];

                return {
                    ...prev,
                    [sourceTeamId]: newSourceList,
                    [overId]: newTargetList,
                };
            });

            SuccessToast()
        } catch (error) {
            console.error("Failed to move accountant", error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <Wrapper>
            <div className='manager-stuff'>
                <div className="d-flex align-items-center justify-content-end flex-row w-100">
                    <Link to="/main_employee/staff" className="change_team"><FlipCameraAndroidIcon/></Link>
                </div>
                <DndContext onDragEnd={handleDragEnd}>
                    <TeamBoard loading={loading} teams={teams} employees={employees}/>
                </DndContext>
            </div>
        </Wrapper>
    );
}

export default StaffTeams;